import { removerCaracteresEspeciais } from '../../../../../util/formatters/stringNormalizer';

function performAlternativaQuery(data, keywords) {
  const perguntasPrincipais = data.perguntas_principais;
  const perguntaPrincipal = perguntasPrincipais[0];

  const perguntasCruzadasFiltradas = perguntaPrincipal.perguntas_cruzadas
    .map((perguntaCruzada) => {
      const alternativasFiltradas = perguntaCruzada.alternativas.filter((alternativa) => removerCaracteresEspeciais(alternativa.enunciado)
        .toLowerCase()
        .includes(removerCaracteresEspeciais(keywords).toLowerCase()));

      if (alternativasFiltradas.length === 0) {
        return null;
      }

      return {
        ...perguntaCruzada,
        alternativas: alternativasFiltradas,
      };
    })
    .filter((perguntaPrincipal) => perguntaPrincipal !== null);

  return {
    ...data,
    perguntas_principais: [
      {
        ...perguntaPrincipal,
        perguntas_cruzadas: perguntasCruzadasFiltradas,
      },
    ],
  };
}

/**
 * realiza a filtragem dos dados passados baseado nas keywords
 * de busca
 *
 * a filtragem eh realizada pelo enunciado da pergunta
 */
function performPerguntaQuery(data, keywords) {
  if (!keywords || keywords.length === 0) return data;

  const perguntas_cruzadas = data.perguntas_principais[0].perguntas_cruzadas.filter(
    (pergunta) => removerCaracteresEspeciais(pergunta.enunciado)
      .toLowerCase()
      .includes(removerCaracteresEspeciais(keywords).toLowerCase()),
  );

  return {
    ...data,
    perguntas_principais: [
      {
        ...data.perguntas_principais[0],
        perguntas_cruzadas,
      },
    ],
  };
}

export function performQuery(data, query, queryStrategy = 'filtrarPergunta') {
  if (!data) {
    return data;
  }

  return {
    filtrarPergunta: performPerguntaQuery(data, query),
    filtrarAlternativa: performAlternativaQuery(data, query),
  }[queryStrategy];
}
